import { extend } from "vee-validate";
import { required, email, min, numeric  } from "vee-validate/dist/rules";
//import i18n  from "./i18n";

/*
configure({
    defaultMessage: (field, values) => {
        // override the field name.
        //values._field_ = i18n.t(`fields.${field}`);

        return i18n.t(`validation.${values._rule_}`);
    }
});
*/

// Install required rule and message.
extend("isLegal", {
    validate: value => {
        return value;
    },
    message: 'Please accept our Privacy Policy to continue'
});

extend("required", {
    ...required,
    message: 'This field is required'
});

extend("email", {
    ...email,
    message: 'This is not a valid email'
});

extend("numeric", {
    ...numeric,
    message: 'This field must be a number'
});

extend("min", {
    ...min,
    message: 'This field must contain 8 characters'
});

extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
    message: 'Password confirmation does not match'
});